import * as Yup from 'yup';

export const CreateCompanyFormValidationSchema = Yup.object({
  name: Yup.string().trim().required('Name of the Company is Required'),
  companyCode: Yup.string().trim().required('Company code is Required'),
  email: Yup.string()
    .trim()
    .email('Invalid E-Mail Format')
    .required('E-Mail is Required'),
  phoneNumber: Yup.string()
    .trim()
    // .matches(/^\d{10}$/, 'Phone Number must be 10 digits')
    .required('Required'),
  addressLine1: Yup.string().trim().required('Address is Required'),
  landmarks: Yup.string().trim().required('A landmark is required'),
  pincode: Yup.string()
    .trim()
    .required('Required')
    .matches(/^\d{6}$/, 'Pincode must be 6 digits'),
  city: Yup.string().trim().required('Required'),
  state: Yup.string().trim().required('Required'),
  country: Yup.string().trim().required('Required'),
  panNumber: Yup.string()
    .trim()
    .matches(/^[A-Z0-9]{10}$/, 'PAN Number must be 10 Alphanumeric Characters')
    .required('PAN Number is Required'),
  gstNumber: Yup.string()
    .trim()
    .matches(/^[A-Z0-9]{15}$/, 'GST Number must be 15 Alphanumeric Characters')
    .required('GST Number is Required'),
});
